/**
 * ContentTagRemapper
 * Maps raw Firestore data to ContentTag DTO and Entity
 *
 * Firestore field names:
 * - name: string
 * - uses: number
 * - is_hashtag: boolean (JsonKey in Flutter)
 */

import type { ContentTagDto } from '@/data/dtos/contentTag/contentTagDto';
import type { JsonObject } from '@/data/types/json';
import type { ContentTagEntity } from '@/domain/entities/contentTag/contentTagEntity';

export class ContentTagRemapper {
  /**
   * Maps raw Firestore data to ContentTag DTO
   */
  static fromJson(data: JsonObject): ContentTagDto {
    return {
      name: (data['name'] as string | undefined) || '',
      uses: (data['uses'] as number | undefined) || 0,
      isHashtag: data['is_hashtag'] as boolean | undefined,
      // Used to recommend hash tags when
      // first typing # when adding a hash tag.
      // Will set value when tapping a hash tag in the feed
      // and when using a hash tag in a post, but will be 0 for all other content tags.
      localUses: 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): ContentTagDto[] {
    return dataList.map(data => ContentTagRemapper.fromJson(data));
  }

  static toEntity(dto: ContentTagDto): ContentTagEntity {
    return { ...dto } as ContentTagEntity;
  }
}
